import React, { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Mousewheel, Keyboard, Navigation } from "swiper/modules";
import RenderStars from "../../components/renderStars/renderStars";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./CustomerReviews.css";

function CustomerReviews() {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const swiperRef = useRef(null);
  const [reviews, setReviews] = useState([]);

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/review?action=list`)
      .then((res) => {
        const activeReviews = res.data.filter((item) => item.status === "1");
        setReviews(activeReviews);
      })
      .catch((err) => {
        console.error("Yorumlar alınamadı:", err);
      });
  }, []);

  return (
    <>
      <Swiper
        onSlideChange={(swiper) => setCurrentIndex(swiper.activeIndex)}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        cssMode={true}
        navigation={{ clickable: true }}
        pagination={false}
        mousewheel={true}
        keyboard={true}
        modules={[Navigation, Pagination, Mousewheel, Keyboard]}
        className="mySwiper"
      >
        {reviews.length > 0 ? (
          reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="bordercolor p-3 rounded">
                <div className="d-flex justify-content-between mt-2">
                  <div className="d-flex">
                    <img
                      src="https://apimukemel.com/api/assets/profile.png"
                      alt="User"
                      width={60}
                      height={60}
                      className="rounded me-2"
                    />
                    <div>
                      <h6 className="mb-1 mt-2">
                        {review.name
                          ?.split(" ")
                          .map((n) => n.charAt(0).toUpperCase() + "...")
                          .join(" ")}
                      </h6>
                      <RenderStars rating={parseInt(review.rating)} />
                    </div>
                  </div>
                  <div className="text-muted me-2">
                    {new Date(review.created_at).toLocaleDateString("tr-TR")}
                  </div>
                </div>

                <div className="mt-3 borderheight">
                  {/* <p className="mb-0">{review.comment}</p> */}
                  <p className="mx-2"> {truncateText(review.comment, 230)}</p>
                </div>
              </div>
            </SwiperSlide>
          ))
        ) : (
          <div className="alert alert-danger text-center" role="alert">
            {t("noReviewsTitle")}
          </div>
        )}
      </Swiper>

      {reviews.length > 0 && (
        <div className="text-center mt-2">
          {currentIndex + 1} / {reviews.length}
        </div>
      )}
    </>
  );
}

export default CustomerReviews;
